import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';

/**
 * Icon-only actions cell renderer shared by every DataGrid's "actions" column.
 * Invotrix convention: actions columns show icons only, wrapped in a Tooltip —
 * never a text Button. See agent memory: project_datagrid_actions_convention.
 *
 * `actions`: Array<{
 *   key: string,
 *   icon: React.ComponentType,
 *   title: string,
 *   color?: 'info' | 'primary' | 'error' | 'default' | ...,
 *   onClick: () => void,
 *   disabled?: boolean,
 *   hidden?: boolean,
 * }>
 */
const GridActionsCell = ({ actions }) => (
  <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', height: '100%' }}>
    {actions
      .filter((action) => !action.hidden)
      .map(({ key, icon: Icon, title, color = 'default', onClick, disabled }) => (
        <Tooltip key={key} title={title}>
          <span>
            <IconButton size="small" color={color} onClick={onClick} disabled={disabled}>
              <Icon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      ))}
  </Box>
);

export default GridActionsCell;
